import { motion } from "framer-motion";
import { Camera } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const PHOTOS = [
  {
    id: "noctali",
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_tableaux-custom/artifacts/de873a223ddfca0f_1792662486768.webp",
    title: "Noctali V",
    place: "L'écrin céleste, sur son socle",
    rotate: "-rotate-2",
  },
  {
    id: "sacha",
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_tableaux-custom/artifacts/3cbbbdcb074cf8f2_1792662405915.webp",
    title: "Pikachu & Sacha",
    place: "Pleine lumière sur l'étagère",
    rotate: "rotate-0",
  },
  {
    id: "alakazam",
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_tableaux-custom/artifacts/b2cc92e198700671_1792662342377.webp",
    title: "Alakazam ex",
    place: "L'échiquier du temps",
    rotate: "rotate-2",
  },
];

export default function ClientPhotos() {
  return (
    <section id="photos-clients" className="relative py-20 md:py-28">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div className="absolute right-1/4 top-1/4 h-[320px] w-[320px] rounded-full bg-cyan-500/10 blur-[120px]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: EASE }}
          className="mb-12 text-center md:mb-16"
        >
          <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-cyan-300">07 — Photos clients</p>
          <h2 className="mx-auto max-w-3xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Vos œuvres, installées chez <span className="text-holo">nos collectionneurs</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-[#a09bb5] sm:text-base">
            Le plus beau moment ? Recevoir la photo du tableau une fois accroché. En voici trois,
            prises chez des collectionneurs après livraison.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-3 sm:gap-6">
          {PHOTOS.map((p, i) => (
            <motion.figure
              key={p.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.7, ease: EASE, delay: i * 0.12 }}
              data-testid={`client-photo-${p.id}`}
              className={`${p.rotate} transition-transform duration-500 hover:rotate-0 hover:scale-[1.03]`}
            >
              <div className="relative overflow-hidden rounded-2xl border border-white/15 bg-[#100e19] shadow-[0_25px_60px_-20px_rgba(0,0,0,0.8)]">
                <img
                  src={p.src}
                  alt={`${p.title} — ${p.place}`}
                  loading="lazy"
                  className="aspect-[3/4] w-full object-cover"
                />
                <div
                  className="pointer-events-none absolute inset-0 bg-[linear-gradient(115deg,transparent_35%,rgba(255,255,255,0.14)_48%,transparent_60%)]"
                  aria-hidden="true"
                />
              </div>
              <figcaption className="mt-4 flex items-center gap-2.5 px-1">
                <Camera size={14} className="shrink-0 text-amber-300" />
                <div>
                  <p className="text-sm font-bold text-white">{p.title}</p>
                  <p className="text-xs text-[#a09bb5]">{p.place}</p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: EASE, delay: 0.2 }}
          className="mt-10 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-[#6c6685]"
        >
          La vôtre fera partie des prochaines — envoyez-la moi après installation
        </motion.p>
      </div>
    </section>
  );
}
